import { Component, computed, inject, input } from '@angular/core';
import { Router } from '@angular/router';
import { NursingAllowanceDurationWidgetStore } from './nursing-allowance-duration-widget.store';
import { nursingAllowanceDurationWidgetFragment } from './nursing-allowance-duration-widget.query';
import { UserWidgetSetting } from '@libs/types/src/services/types/service-settings-user-widgets.type';
import { NursingAllowanceCareTypeEnum } from '@libs/types/src/services/enum/nursing-allowance-care-type.enum';
import { NursingAllowanceStateEnum } from '@libs/types/src/services/enum/nursing-allowance-state.enum';
import {
    FolderNursingAllowanceObject,
} from '@libs/types/src/services/object-type/folder/folder-nursing-allowance.object';
import { TableComponent } from '../../../../../shared/components/kit/table/table.component';
import { TableColumn, TableColumnType } from '../../../../../shared/components/kit/table/table.types';
import { clientChipField, serviceField } from '../../../../../shared/components/kit/table/table.fields';
import { translate } from '../../../../../shared/shared.global-service';
import { folderUri } from '../../../../../../utils/router.utils';

@Component({
    selector: 'app-nursing-allowance-duration-widget',
    templateUrl: './nursing-allowance-duration-widget.component.html',
    styleUrl: './nursing-allowance-duration-widget.component.scss',
    imports: [TableComponent],
    providers: [NursingAllowanceDurationWidgetStore],
})
export class NursingAllowanceDurationWidgetComponent {
    protected readonly store = inject(NursingAllowanceDurationWidgetStore);
    private readonly router = inject(Router);

    items = input<{ serviceId: string, widget: UserWidgetSetting }[]>([]);

    protected readonly fragment = nursingAllowanceDurationWidgetFragment;
    protected readonly columns: TableColumn[] = [
        clientChipField('client', 'folder.person', false),
        serviceField('service', 'folder.serviceId'),
        {
            name: 'deceased',
            dataKey: 'folder.person.dateDeath',
            type: TableColumnType.Tag,
            data: (date: string | null) => translate.instant(date
                ? 'nursingAllowance.widgets.yes' : 'nursingAllowance.widgets.no'),
            severity: (_value, item: FolderNursingAllowanceObject) => item.folder?.person?.dateDeath
                ? 'danger' : 'secondary',
        },
        {
            name: 'duration',
            dataKey: 'durationDays',
            type: TableColumnType.Tag,
            data: (days: number | null) => days === null ? '—'
                : translate.instant('nursingAllowance.days', { count: days }),
            severity: (_value, item: FolderNursingAllowanceObject) => item.durationDays === null ? 'secondary'
                : item.durationDays > 80 ? 'danger' : item.durationDays > 70 ? 'warn' : 'success',
        },
    ];

    protected readonly additionalFilter = computed(() => [
        [{ column: 'serviceId', operator: 'IN', value: this.items().map(item => item.serviceId) }],
        [{ column: 'careType', operator: 'EQ', value: [NursingAllowanceCareTypeEnum.LONG_TERM] }],
        [{ column: 'state', operator: 'EQ', value: [NursingAllowanceStateEnum.OPEN] }],
        [{ column: 'activeIcpe', operator: 'EQ', value: ['true'] }],
    ]);

    protected openDetail(item: FolderNursingAllowanceObject): void {
        void this.router.navigateByUrl(folderUri(item.folderId, item.folder?.serviceId, 'nursing-allowance/' + item.id));
    }
}
